import React from 'react';
import type {FetchVacancyResponse} from '@rocket-ui/lk-api';
import styles from './OfferPage.module.css';

type VacancyService = NonNullable<FetchVacancyResponse['services']>[number];

interface OfferServicesListProps {
	services: VacancyService[];
}

function formatRublesFromCents(cents?: number | null): string {
	if (cents == null) return '—';
	return `${(cents / 100).toLocaleString('ru-RU')} ₽`;
}

function formatQuantity(quantity?: string | null): string {
	if (quantity == null || quantity === '') return '—';
	const asNumber = Number(quantity);
	if (!Number.isNaN(asNumber)) return String(asNumber);
	return quantity;
}

function getServiceCalc(service: VacancyService): string {
	const quantity = formatQuantity(service.quantity);
	const unit = (service.unit?.trim() || 'шт').replace(/\.$/, '');
	const unitPrice = formatRublesFromCents(service.unitPrice?.amountCents);

	return `${quantity} ${unit}. X ${unitPrice}`;
}

export function OfferServicesList({services}: OfferServicesListProps): React.ReactElement {
	return (
		<ul className={styles.servicesList}>
			{services.map((service, index) => {
				const order = service.order ?? index + 1;
				const title = service.description?.trim() || `Услуга #${order}`;
				const total = formatRublesFromCents(service.totalPrice?.amountCents);

				return (
					<li key={`${order}-${index}`} className={styles.serviceItem}>
						<span className={styles.serviceIndex}>{order}</span>
						<div className={styles.serviceBody}>
							<p className={styles.serviceTitle}>{title}</p>
							<p className={styles.serviceCalc}>{getServiceCalc(service)}</p>
						</div>
						<p className={styles.serviceTotal}>{total}</p>
					</li>
				);
			})}
		</ul>
	);
}
